<template>
    <mc-container :title="title" :tips="currentTips" >
        <div class="mc-select"
             :class="{focus:visible}"
             v-clickoutside="handleClose">
            <div @click="clickSelect">
                <input ref="input"
                       type="text"
                       readonly
                       class="mc-select__input"
                       :class="{
                            'is-error': !!currentTips
                        }"
                       :placeholder="placeholder"
                       v-model="selectedLabel"
                       :disabled="disabled"
                       :title="selectedLabel"
                >
                <i class="mc-select__icon fa fa-angle-down" ></i>
            </div>
            <dropdown
                    v-show="visible"
                    :style="dropdownXY">
                <div class="mc-select__box" ref="panel">
                    <slot></slot>
                </div>

            </dropdown>
        </div>
    </mc-container>

</template>

<script type="text/ecmascript-6">
    /**
     * ** 钩子函数
     * bind:              只调用一次，指令第一次绑定到元素时调用
     * inserted:          被绑定元素插入父节点时调用（仅保证父节点存在，但不一定已插入）
     * update:            所在组件的VNode更新时调用，但可能发生在其子VNode更新之前
     * componentUpdated:  指令所在组件的VNode及其子VNode全部更新后调用
     * unbind:            只调用一次，指令与元素解绑时调用
     *
     *
     * ** 指令钩子参数
     *    el:       指令所绑定的DOM元素
     *    binding:  一个对象，包含以下属性
     *                name:       指令名，不包括 v- 前缀
     *                value:      指令的绑定值
     *                oldValue:   指令绑定的前一个值（仅在update/componentUpdated钩子中可用）
     *                expression: 字符串形式的指令表达式
     *                arg:        传给指令的参数 如   v-my-directive:foo中，参数为foo
     *                modifiers:  一个包含修饰符的对象。如 v-my-dircetive.foo.bar中，修饰符对象为{foo: true, bar: true}
     *    vnode:    Vue生成的虚拟节点
     *    oldVnode: 上一个虚拟节点（仅在update/componentUpdated钩子中可用）
     * */

    import Emitter from '../mixins/emitter'
    import McContainer from './base-container'
    import dropdown from './base-dropdown'
    import AsyncValidator from 'async-validator';
    import {getStyleComputedProperty, getScrollParent} from '../utils/util'
    export default {
        mixins: [Emitter],
        name: 'base-selectbox',
        provide() {
            return {
                'selectbox': this
            };
        },
        computed: {
            // 下拉框坐标
            dropdownXY() {
                return {
                    top: this.rect.bottom + 'px',
                    left: this.rect.left + 'px',
                    width: '500px'
                    //width: this.rect.width + 'px'
                }
            }
        },
        components: {
            McContainer, dropdown
        },
        props: {
            value: {
                type: [String, Number],
                description: '默认选中(value)',
                required: true
            },
            title: {
                type: String,
                description: '组件标题',
            },
            tips: {
                type: String,
            },
            disabled: {
                type: Boolean,
                description: '禁用',
                default: false
            },
            validateEvent: {
                type: Boolean,
                default: true
            },
            rules: {
                type: [Object, Array]
            },
            placeholder: {
                type: [String, Number],
                default: '请选择'
            }
        },
        slotData: [
            {
                name: 'default',
                type: ['base-selectbox-tabs']
            },
            {
                name: 'title',
                type: ['text']
            }
        ],


        data() {
            return {
                options: [],
                cachedOptions: [],
                selected: {},
                selectedLabel: '',
                query: '',

                visible: false,
                selectMultiple: false,
                currentTips: this.tips,
                rect: {
                    bottom: 0,
                    left: 0,
                    width: 0
                }
            }
        },
        watch: {
            value(val){
                this.setSelected();
            },
            options() {
                this.setSelected();
            },
            tips(val){
	            this.currentTips = val;
            }
        },

        directives: {
            clickoutside: {
                bind(el, binding, vnode) {
                    function documentHandler(e) {
                        if (el.contains(e.target)) {  // 判断点击区域是否是指令所在的元素内部
                            return false;               // 是 则跳出函数
                        }

                        if (binding.expression) {     // 判断当前指令（v-clickoutside），是否写了表达式（应为函数
                            binding.value(e);           // 执行指令绑定的函数，即 _handleClose
                        }
                    }
                    function resetRect() {
                        // 修正dropdown坐标
//                        vnode.context.rect = el.getBoundingClientRect();
                        vnode.context.resitRect();
                    }

                    el.__vueClickOutside__ = documentHandler;
                    el.__vueScroll__ = resetRect;
                    document.addEventListener('click', documentHandler);
                    document.addEventListener('scroll', el.__vueScroll__);
                    document.addEventListener('resize', el.__vueScroll__);

                },
                inserted(el){
                    let target = getScrollParent( el );
                    target.addEventListener('scroll', el.__vueScroll__);
                },
                unbind(el, binding) {
                    let target = getScrollParent( el );
                    target.removeEventListener('scroll', el.__vueScroll__);
                    document.removeEventListener('click', el.__vueClickOutside__);
                    document.removeEventListener('resize', el.__vueScroll__);
                    document.removeEventListener('scroll', el.__vueScroll__);

                    delete el.__vueClickOutside__;
                    delete el.__vueScroll__;
                    delete el.__vueResize__;

                }
            }
        },


        methods: {

            // 点击 input
            clickSelect(e) {
                if(this.disabled){return}
                this.visible = !this.visible;
                // 获取 input 坐标
//                this.rect = e.currentTarget.getBoundingClientRect();
                this.resitRect();
            },
            resitRect(){
                if(!this.visible){ return; }
                this.$nextTick(()=>{
                    let panelRect = this.$refs.panel.getBoundingClientRect();
                    let windowH = window.innerHeight;
                    let inputRect = this.$refs.input.getBoundingClientRect();

                    console.log('>>>>>>', panelRect)


                    if( (windowH - inputRect.bottom) > panelRect.height ) {
                        console.log('显示在下方')
                        this.rect = inputRect;
                    }else{
                        console.log('显示在上方 ' );
                        this.rect = {
                            bottom  : inputRect.top - panelRect.height,
                            left    : inputRect.left,
                            width   : inputRect.width
                        }
                    }
                })


            },

            // 关闭下拉
            handleClose() {
                this.visible = false;
            },


            // 选中子项
            handleOptionSelect(option) {
                console.log('>>>>>>>>>', option)
                this.$emit('input', option.value);
                this.emitChange(option);
                this.visible = false;

            },
            emitChange(val) {
                let data = {
                    value: val.value,
                    label: val.label,
                    item: val.item
                }
                if (this.value !== val.value) {
                    this.$emit('change', data);
                    this.rules && this.validate('change', val.value);
                    if (this.validateEvent) {
                        this.dispatch('mcFormItem', 'el.form.change', [val.value]);
                    }
                }
            },

            getOption(value) {
                let option;
                for (let i = this.cachedOptions.length - 1; i >= 0; i--) {
                    const cachedOption = this.cachedOptions[i];
                    const isEqual = cachedOption.value === value;
                    if (isEqual) {
                        option = cachedOption;
                        break;
                    }
                }
                console.log('getOption',option)

                if (option) return option;



                let newOption = {
                    value: value,
                    currentLabel: ''
                };

                return newOption;


            },
            setSelected() {
                let option = this.getOption(this.value);
                this.selectedLabel = option.currentLabel;
                this.selected = option;
            },
            // 清空校验
            resetValidateHandler: function () {
                this.currentTips = '';
            },
            /**
             * 判断输入内容
             * @param trigger
             * @param callback
             */
            validate: function (trigger, value, callback = function () {}) {
                let rule = this.getRules(trigger);
                if(!rule || !rule.length){
                    return false
                }
                const schema = new AsyncValidator({name: rule});
                schema.validate({name: value}, (errors, field) => {
                    if(errors){
                        this.currentTips = errors[0].message
                    }else{
                        this.currentTips = ''
                    }
                })
            },
            /**
             * 获取判断规则
             * @param trigger
             */
            getRules: function (trigger) {
                //过滤掉trigger为空和trigger传入参数不一致的rule
                return this.rules.filter(rule => !rule.trigger || rule.trigger.indexOf(trigger) !== -1)
            },

        },
        created(){
            this.$on('handleOptionClick', this.handleOptionSelect);
        },
        mounted() {
            if(this.value.length > 0){
                this.setSelected();
            }
            this.$on('resetValidate', this.resetValidateHandler);


        },
    }
</script>



// WEBPACK FOOTER //
// src/components/base-selectbox.vue